import React, { useCallback, useEffect, useState } from "react";
import { Header } from "build-ts/metadata";
import { listScheduledJobs } from "services/ScheduleServices";
import { useUser } from "context/UserContext";
import WorkflowRuns from "modules/workflow/components/WorkflowRuns";

interface WorkflowRunsContainerProps {
  analystsList: Header[];
  isTabActive: boolean;
}

const WorkflowRunsContainer: React.FC<WorkflowRunsContainerProps> = ({ analystsList, isTabActive }) => {
  const { defaultAnalystId } = useUser();

  const [selectedAnalyst, setSelectedAnalyst] = useState<Header | null>(null);
  const [scheduledJobs, setScheduledJobs] = useState<Header[]>([]);
  const [isLoadingJobs, setIsLoadingJobs] = useState(false);
  const [selectedJob, setSelectedJob] = useState<Header | null>(null);

  // Auto-select default analyst when list loads
  useEffect(() => {
    if (analystsList.length === 0) return;
    const defaultAnalyst = analystsList.find(a => a.id === defaultAnalystId) || analystsList[0];
    setSelectedAnalyst(defaultAnalyst);
  }, [defaultAnalystId, analystsList]);

  // Fetch workflows whenever the selected analyst or tab active state changes
  useEffect(() => {
    if (!selectedAnalyst?.id || !isTabActive) return;
    fetchJobs(selectedAnalyst.id);
  }, [selectedAnalyst?.id, isTabActive]);

  const fetchJobs = useCallback(async (analystId: string) => {
    setIsLoadingJobs(true);
    setScheduledJobs([]);
    setSelectedJob(null);
    const response = await listScheduledJobs("SCENARIO_JOB", -1, 1, analystId, "LAST_MODIFIED", false, true, "");
    setScheduledJobs(response || []);
    setIsLoadingJobs(false);
  }, []);

  const handleSelectAnalyst = useCallback((analyst: Header) => {
    setSelectedAnalyst(analyst);
  }, []);

  const handleSelectJob = useCallback((job: Header) => {
    setSelectedJob(job);
  }, []);

  return (
    <WorkflowRuns
      analystsList={analystsList}
      selectedAnalyst={selectedAnalyst}
      scheduledJobs={scheduledJobs}
      isLoadingJobs={isLoadingJobs}
      selectedJob={selectedJob}
      isTabActive={isTabActive}
      onSelectAnalyst={handleSelectAnalyst}
      onSelectJob={handleSelectJob}
    />
  );
};

export default WorkflowRunsContainer;
